import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import configs from '@/configs';

Vue.use(Router);
const router = new Router({
    base: '/',
    mode: 'hash',
    linkActiveClass: 'active',
    routes: paths,
    mode: 'history'
});

// router gards
router.beforeEach((to, from, next) => {
  let isAuthenticated = localStorage.getItem('jwt') !== null;
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) next({ name: 'dang-nhap' })
  else next()
  Vue.nextTick(() => {
    document.title = to.meta.title ? to.meta.title + (to.params.Pid ? ' #' + to.params.Pid : '') + ' | ' + configs.DEFAULT_TITLE : configs.DEFAULT_TITLE;
  });
});

export default router
